import { render } from "./QuantumHRWorkflowAssistantTabs.vue?vue&type=template&id=35842aa6"
import script from "./QuantumHRWorkflowAssistantTabs.vue?vue&type=script&lang=js"
export * from "./QuantumHRWorkflowAssistantTabs.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__